import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
export var stripSchemaFormats = function (schema, whitelist) {
    if (whitelist === void 0) { whitelist = []; }
    var newSchema = cloneDeep(schema);
    var _strip = function (schema) {
        if (schema.format && whitelist.indexOf(schema.format) === -1) {
            delete schema.format;
        }
        if (schema.properties) {
            forEach(schema.properties, function (subSchema) {
                _strip(subSchema);
            });
        }
        if (schema.items) {
            _strip(schema.items);
        }
    };
    _strip(newSchema);
    return newSchema;
};
export var disallowAdditionalProperties = function (schema) {
    var newSchema = cloneDeep(schema);
    var disallow = function (schema) {
        if (schema.additionalProperties) {
            schema.additionalProperties = false;
        }
        if (schema.properties) {
            forEach(schema.properties, function (subSchema) {
                disallow(subSchema);
            });
        }
    };
    disallow(newSchema);
    return newSchema;
};
